import React from "react";
import {
  Filter,
  TextInput,
  BooleanInput,
  Button,
  Link,
  ReferenceInput,
  SelectInput,
  Create,
  List,
  DateInput,
  NumberInput,
  Datagrid,
  TextField,
  Pagination,
  DisabledInput,
  DateField,
  Edit,
  SimpleForm,
  EditButton
} from "react-admin";
import ChatBubbleIcon from "@material-ui/icons/ChatBubble";
import moment from "moment";
// import ItemSwitch from "../components/itemSwitch";
import { CustomBaseFilter } from "../components/selectboxfilter/customBaseFilter";

const TankbagPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const tankBagTypes = [
  { _id: "tank", description: "Tank" },
  { _id: "seat", description: "Seat" }
];

const TankbagFielter = props => (
  <Filter {...props}>
    <CustomBaseFilter label="Base Location" source="location_id" alwaysOn />
  </Filter>
);

const HistoryButton = props => (
  <Button
    component={Link}
    to={{
      pathname: `/item_history/tankbags/${props.record.id}`
    }}
    label="Device History"
  >
    <ChatBubbleIcon />
  </Button>
);

// const SwitchButton = props => {
//   const rentals = props.record.number_rentals || 0;
//   if (rentals > 0 && props.record.status === 1) {
//     return (
//       <ItemSwitch
//         item={props.record}
//         type={props.resource}
//         history={props.history}
//         location={props.location}
//       />
//     );
//   }
//   return <React.Fragment />;
// };
export const TankbagList = props => (
  <List
    {...props}
    resource="tankbags"
    pagination={<TankbagPagination />}
    filters={<TankbagFielter />}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Tankbag ID" source="id" sortable={false} />
      <TextField
        label="Last Location"
        source="location_name"
        sortable={false}
      />
      <TextField label="Tankbag Model" source="model" sortable={false} />
      <DateField
        label="Purchase Date"
        source="purchase_date"
        sortable={false}
      />
      <EditButton />
      <HistoryButton />
    </Datagrid>
  </List>
);

const TankbagTitle = object => (
  <span>
    {" Edit Tankbag Device"} &quot;{object.record.model}&quot;
  </span>
);

const TankbagCreateTitle = record => <span>Create Tankbag Device</span>;

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const TankbagCreate = props => (
  <Create title={<TankbagCreateTitle />} {...props}>
    <SimpleForm>
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <SelectInput
        label="Type"
        source="type"
        choices={tankBagTypes}
        optionText="description"
        optionValue="_id"
      />
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
      <ReferenceInput
        label="Vehicle Model"
        source="vehicle_model_id"
        reference="vehicle_models"
        sort={{ field: "model_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="model_name" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export const TankbagEdit = props => (
  <Edit title={<TankbagTitle />} {...props}>
    <SimpleForm>
      <DisabledInput label="Id" source="id" />
      <TextInput label="Model" source="model" />
      <DateInput label="Purchase Date" source="purchase_date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
      <NumberInput source="purchase_price" label="Purchase Price" />
      <BooleanInput label="Status" source="status" />
      <SelectInput
        label="Type"
        source="type"
        choices={tankBagTypes}
        optionText="description"
        optionValue="_id"
      />
      <ReferenceInput
        label="Vehicle Model"
        source="vehicle_model_id"
        reference="vehicle_models"
        sort={{ field: "model_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="model_name" />
      </ReferenceInput>
      <ReferenceInput
        label="Primary Location"
        source="location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <SelectInput source="id" optionText="location_name" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);



// WEBPACK FOOTER //
// ./src/resources/tankbags.js